import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch user admin list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} username search user admin by username
 *  @param {String} sort sort user admin by, format: field;ASC|DESC
 */
const fetchUserAdminList = async function (filters) {
  try {
    let res = await axios.get(urls.getListUser + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a user admin's detail
 * @param {Number} userAdminId user admin id
 */
const fetchUserAdminDetail = async function (userAdminId) {
  try {
    let res = await axios.get(urls.userDetail + '/' + userAdminId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create and edit UserAdmin
 * @param {Object} form submitted form
 * @param {String} form.clientId user admin clientId
 * @param {String} form.email user admin email
 * @param {String} form.role user admin role
 * @param {String} form.phone user admin phone
 * @param {String} form.imageUrl user admin imageUrl
 * @param {Number} [userId] UserAdmin Id for edit detail
 */
const createEditUserAdmin = async function (form, userId) {
  try {
    let res
    if (!userId) {
      res = await axios.post(urls.userDetail, form)
    } else {
      res = await axios.put(urls.userDetail + '/' + userId, form)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Set user admin's activation status
 * @param {Number} userId UserAdmin's Id
 * @param {Number} isActive set the user admin's activation in binary boolean (1|0)
 */
const setUserAdminActivation = async function (userId, isActive) {
  try {
    let data = {
      userId,
      isActive
    }
    let res = await axios.post(urls.userActivation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const deleteAdmin = async function (userAdminId) {
  try {
    let res = await axios.delete(urls.userDetail + '/' + userAdminId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const resetPassword = async function (userId) {
  try {
    let res = await axios.post(urls.userResetPassword, { userId })
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchUserAdminList,
  createEditUserAdmin,
  fetchUserAdminDetail,
  setUserAdminActivation,
  deleteAdmin,
  resetPassword,
}
